<template>
  <b-container>
    <b-card no-body>
      <b-table :items="users"></b-table>
    </b-card>
  </b-container>
</template>

<script>

export default {
  name: 'users',
  props: ['user', 'profile'],
  metaInfo() {
    return {
      title: `Users`
    };
  },
  data() {
    return {
      users: [
        {email: this.user.email, role: 'owner'}
      ]
    }
  }
}
</script>

<style scoped>

.header {
  padding: 0px;
}

.jumbotron {
  background: #353e58;
  margin-bottom: 0px !important;
}

.main {
  background: white;
  position: relative;
  top: -64px !important;
}

</style>
